import {
    Button,
    Grid,
    Box,
    IconButton,
    Stack,
    Typography,
    TextField as MuiTextField,
    Checkbox,
    Radio
  } from '@mui/material';
  import { useForm } from 'react-hook-form';
  import CloseIcon from '@mui/icons-material/Close';
  import { FormProvider, SelectTag,  TextField } from '../../../../../components';
  import {  useState } from 'react';
  import { yupResolver } from '@hookform/resolvers/yup';
  import * as Yup from 'yup';
  import { DIET_TYPE } from '../../../../../constants/dropdown';
  import { request } from '../../../../../utils';
  import { toast } from '../../../../../utils';
  import { useLocation } from 'react-router-dom';
  

  
  export const DietManagementDetailForm = ({ onClose,ipdNo,uhid,  searchIPDRegisterationDetails }) => {
    const[loading,setLoading] = useState(false)
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const pathParts = pathname.split('/');
    const organisation = pathParts[1];
    const user = JSON.parse(localStorage.getItem('user'));

    const methods = useForm({
      resolver: yupResolver(
        Yup.object().shape({
          diet_type: Yup.string().required('Please Enter Product')
        })
      ),
      defaultValues: {
        po_qty: 0,
        free_qty: 0,
        loose_qty: 0,
        rec_qty: 0,
        quantity: 1,
        amount: 0,
        net_amt: 0,
        gst_amt: 0,
        disc_amt: 0,
        disc_per: 0,
        gst_per: 0,
        sgst: 0,
        cgst: 0
      },
      mode: 'all'
    });
    const { reset } = methods;
  
    const { handleSubmit, setValue, watch } = methods;
  
    const formSubmit = async (formValues) => {
        setLoading(true);
        const response = await request('/diet-management-create', {
          method: 'POST',
          body: {
            ...formValues,
            ipd_no: ipdNo,
            uhid: uhid,
            createdBy: user.name,
            organisation
          }
        });
        if (response?.success) {
          toast(`Successfully  Diet Created Successfully`, { variant: 'success' });
          reset();
          searchIPDRegisterationDetails(ipdNo)
        } else {
          toast(`Failed to create Diet `, {
            variant: 'error'
          });
        }
        setLoading(false);
      };

  
    return (
      <Stack spacing={1}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          borderBottom="0px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Add Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
  
        <FormProvider
          sx={{ height: '100%', overflow: 'auto' }}
          methods={methods}
          onSubmit={handleSubmit(formSubmit)}
        >
          <Grid container spacing={0.5} sx={{ flex: 0.5, height: '100%', overflow: 'auto' }}>
            <Grid
              item
              xs={4}
              sx={{
                height: '100%',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column'
              }}
            >            
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Diet Type</Typography>
                <SelectTag menus={DIET_TYPE} formControlSX={{ flex: 0.8 }} name="diet_type" placeholder="Enter Diet Type" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Diet Detail</Typography>
                <TextField sx={{ flex: 0.8 }} name="diet_detail" placeholder="Enter Diet Detail"  />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time</Typography>
                <TextField sx={{ flex: 0.4 }} name="date" type="date" />
                <TextField sx={{ flex: 0.4 }} type="time" name="time" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                <TextField sx={{ flex: 0.8 }} name="qty" type="number" />
              </Stack>
              <Stack sx={{marginTop:2}} spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </FormProvider>
      </Stack>
    );
  };
  